export default __webpack_public_path__ + "static/media/todolist.24ff5026.PNG";